import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from "react";
import { auth } from "./firebase";
import MainLayout from "./layout/MainLayout";
import HomePage from "./pages/HomePage";
import ScrollToTop from "./components/ScrollToTop";
import LessonSelectPage from "./pages/LessonSelectPage";
import LessonDetailPage from "./pages/LessonDetailPage";
import GoalsPage from "./pages/GoalsAndJournalPage";
import TrialAnalysisPage from "./pages/TrialAnalysisPage";
import AccountPage from "./pages/AccountPage";
import StudyTimePage from "./pages/StudyTimePage";
import StreakPage from "./pages/StreakPage";
import ForumPage from "./pages/ForumPage";
import FeedbackPage from "./pages/FeedbackPage";
import AdminPanel from "./pages/AdminPanel";
import UserProfilePage from "./pages/UserProfilePage";
import NotificationsPage from "./pages/NotificationsPage";
import MessagesPage from "./pages/MessagesPage";
import ChatPage from "./pages/ChatPage";
import StudyBuddiesPage from "./pages/StudyBuddiesPage";
import FocusRoomPage from "./pages/FocusRoomPage";
import GoogleInitialSetupPage from "./pages/GoogleInitialSetupPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import UpdatesPage from "./pages/UpdatesPage";
import AvatarCreatorPage from "./pages/AvatarCreatorPage";
import PaymentPage from "./PaymentPage";
import CoachDashboardPage from "./pages/coach/CoachDashboardPage";
import CoachStudentDetailPage from "./pages/coach/CoachStudentDetailPage";
import StudentProgramPage from "./pages/student/StudentProgramPage";
// PrivatePremiumRoute kaldırıldı — tüm sayfalar açık erişimli
import { Toaster } from "sonner";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// İç bileşen
function AppContent() {
  const [currentRoom, setCurrentRoom] = useState(null);

  return (
    <>
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/google-setup" element={<GoogleInitialSetupPage />} />
        <Route path="/" element={<MainLayout />}>
          <Route index element={<HomePage />} />
          <Route path="home" element={<HomePage />} />
          <Route path="select-lesson" element={<LessonSelectPage />} />
          <Route path="lesson/:id" element={<LessonDetailPage />} />
          <Route path="goals" element={<GoalsPage />} />
          <Route path="trial" element={<TrialAnalysisPage />} />
          <Route path="account" element={<AccountPage />} />
          <Route path="study-time" element={<StudyTimePage />} />
          <Route path="streaks" element={<StreakPage />} />
          <Route path="leaderboard" element={<StreakPage />} />
          <Route path="forum" element={<ForumPage />} />
          <Route path="messages" element={<MessagesPage />} />
          <Route path="chat/:id" element={<ChatPage />} />
          <Route path="study-buddies" element={<StudyBuddiesPage setCurrentRoom={setCurrentRoom} />} />
          <Route path="study-buddies/:roomId" element={<StudyBuddiesPage setCurrentRoom={setCurrentRoom} />} />
          <Route path="focus-room/:roomId" element={<FocusRoomPage />} />
          <Route path="feedback" element={<FeedbackPage />} />
          <Route path="updates" element={<UpdatesPage />} />
          <Route path="admin" element={<AdminPanel />} />
          <Route path="user/:id" element={<UserProfilePage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="avatar-creator" element={<AvatarCreatorPage />} />
          <Route path="payment" element={<PaymentPage />} />
          <Route path="coach" element={<CoachDashboardPage />} />
          <Route path="coach/student/:id" element={<CoachStudentDetailPage />} />
          <Route path="my-program" element={<StudentProgramPage />} />
          <Route path="payment-success" element={
            <div style={{ textAlign: "center", padding: "20px" }}>
              <h1>Ödeme Başarılı!</h1>
              <p>Ödemeniz başarıyla tamamlandı. Teşekkür ederiz!</p>
              <button onClick={() => window.location.href = '/home'} style={{ padding: "10px 20px", backgroundColor: "#00e676", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
                Ana Sayfaya Dön
              </button>
            </div>
          } />
          <Route path="payment-fail" element={
            <div style={{ textAlign: "center", padding: "20px" }}>
              <h1>Ödeme Başarısız</h1>
              <p>Ödeme işlemi sırasında bir hata oluştu. Lütfen tekrar deneyin.</p>
              <button onClick={() => window.location.href = '/premium'} style={{ padding: "10px 20px", backgroundColor: "#ff4444", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
                Tekrar Dene
              </button>
            </div>
          } />
        </Route>
        <Route path="*" element={<MainLayout><HomePage /></MainLayout>} />
      </Routes>
      <Toaster theme="dark" richColors position="top-right" />
    </>
  );
}

// Ana App bileşeni
function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(() => {
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{ background: "#0a0c12", height: "100vh", color: "#818cf8", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        <div style={{ width: "40px", height: "40px", border: "4px solid #6366f1", borderTop: "4px solid transparent", borderRadius: "50%", animation: "spin 1s linear infinite", marginBottom: "20px" }} />
        <p style={{ fontWeight: 600, letterSpacing: '0.05em' }}>YELKEN</p>
      </div>
    );
  }

  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;